import React from 'react';
import { connect } from 'react-redux';
import { Redirect, Link } from 'react-router-dom';
import { getTexts, deleteTextFromApi, sentText, getRecentTexts } from '../actions/text'
import { getUserEdits, deleteEditFromApi } from '../actions/edit'

import Spinner from './spinner'

import './dashboard.css'

export class Dashboard extends React.Component {
    componentDidMount() {
        if (!this.props.loggedIn) {
            return
        }

        this.props.dispatch(sentText(false))
        this.props.dispatch(getRecentTexts())
        this.props.dispatch(getTexts(this.props.uid))
        this.props.dispatch(getUserEdits(this.props.uid))
    }

    delete(e, title, id, isEdit) {
        e.preventDefault()
        if(!isEdit) {
            if(confirm(`Are you sure you want to delete ${title}?`)) {
                this.props.dispatch(deleteTextFromApi(id, this.props.uid))
            }
        }
        else if(confirm(`Are you sure you want to delete ${title}?`)) {
                this.props.dispatch(deleteEditFromApi(id, this.props.uid))
            }
    }

    render() {
        if (!this.props.loggedIn) {
            return <Redirect to="/" />;
        }

        let userTexts
        this.props.userTexts.length ? userTexts = this.props.userTexts.map((text, i) => {
                return <div className='user-item' key={ i } >
                            <Link to={{
                                pathname: `/text/${text.title}`,
                                state: { textId: text._id }
                            }}>{ text.title }</Link>
                            <button className='x-button' onClick={ e => this.delete(e, text.title, text._id, false) }>X</button>
                        </div>
                })
            : userTexts = <div className='user-item'></div>

        let userEdits
        this.props.userEdits.length ? userEdits = this.props.userEdits.map((edit, i) => {
                return <div className='user-item' key={ 'edit-' + i }>
                        <div className='title-author'>
                            <Link 
                                className='title-name'
                                to={ {
                                pathname: `/edited/${edit.title}`,
                                state: { editId: edit._id }
                            }}>{ edit.title }</Link>
                            <div className='author'>by { edit.authorName }</div>
                            <button className='x-button' onClick={ e => this.delete(e, edit.title, edit._id, true) }>X</button>
                        </div>
                    </div>
                })
            : userEdits = <div className='user-item'></div>

            const spin = !this.props.userEdits.length && !this.props.userTexts.length ? <Spinner /> : <div></div>

        return (
            <div className='row'>
                <div className="dashboard col-12">
                    <h2 className="dashboard-username">
                        Welcome, {this.props.username}
                    </h2>
                    <div className='user-data col-6'>
                        <div className="user-texts col-6">
                            <h3>Your papers:</h3>
                            { userTexts }
                        </div>
                        <div className='user-edits col-6'>
                            <h3>Your edits:</h3>
                            { userEdits }
                        </div>
                    </div>            
                </div>
                { spin }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const {currentUser} = state.auth;
    return {
        loggedIn: currentUser !== null,
        username: currentUser ? state.auth.currentUser.username : '',
        name: currentUser
            ? `${currentUser.firstName} ${currentUser.lastName}`
            : '',
        protectedData: state.protectedData.data,
        uid: state.auth.uid,
        userTexts: state.text.userTexts,
        userEdits: state.edit.userEdits,
        recentTexts: state.text.recentTexts,
        allEdits: state.edit.allEdits
    };
};

export default connect(mapStateToProps)(Dashboard);



// WEBPACK FOOTER //
// ./src/components/dashboard.js